import { SectionedConfigurationForm } from './configuration/SectionedConfigurationForm';

interface Props {
  connectorType: string;
  name: string;
}

export function ConfigurationTab({ connectorType, name }: Props) {
  return <SectionedConfigurationForm connectorType={connectorType} name={name} />;
}
